import { render, staticRenderFns } from "./foot.vue?vue&type=template&id=0e343af8&scoped=true"
import script from "./foot.vue?vue&type=script&lang=js"
export * from "./foot.vue?vue&type=script&lang=js"
import style0 from "./foot.vue?vue&type=style&index=0&id=0e343af8&prod&lang=scss"
import style1 from "./foot.vue?vue&type=style&index=1&id=0e343af8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e343af8",
  null
  
)

export default component.exports